<template>
    <div class="recommend-rank-wrapper">
        <div class="title">更多游戏推荐</div>
        <div
            v-for="(item, index) of list"
            :key="index"
            v-lazy:background-image="item.background"
            class="rank-item-wrapper"
            @click="doJumpPage(item)"
        >
            <!-- v-lazy:background-image="backCss[index % 3]" -->
            <div
                class="rank-item"
                :style="'background-image:' + backCss[index % 3]"
            >
                <div class="rank-item-title">{{ item.rank_name }}</div>
                <div class="rank-item-link">共{{ item.total }}款游戏 <img v-lazy="next"></div>
                <div class="rank-item-list">
                    <div
                        v-for="(v, k) of item.games"
                        :key="k"
                        class="list-item"
                        @click.stop="doJumpDetail(v, k, item.rank_name)"
                    >
                        <img v-lazy="rankIcon[k]" class="rank-icon">
                        <img v-lazy="v.icon" class="item-icon">
                        <div class="app-name over-ellipsis">{{ v.app_name }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="hasMoreData" class="show-more"
            @click="showMore"
        >
            查看更多
        </div>
    </div>
</template>
<script>
import api from '@/api';
import num_1 from 'public/assets/imgs/num1.png';
import num_2 from 'public/assets/imgs/num2.png';
import num_3 from 'public/assets/imgs/num3.png';
import next from 'public/assets/imgs/ic_next.png';
import {getUrlParams, getQueryString} from '@/utils/url';
export default {
    props: {
        moreRank: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            rankIcon: [num_1, num_2, num_3],
            backCss: [
                'linear-gradient(190deg, rgba(255,249,232,0.70) 0%, #FFF5DF 53%)',
                'linear-gradient(190deg, rgba(232,246,255,0.70) 0%, #DFE5FF 53%)',
                'linear-gradient(190deg, rgba(232,246,255,0.70) 0%, #DFEEFF 53%)',
            ],
            pNum: 2,
            hasMoreData: true,
            loadingMoreData: false,
            list: [],
            next: next,
        };
    },
    created() {
        this.list = this.moreRank;
        if (this.list) {
            this.$parent.doShowItemsLog(this.list);
        }

    },
    methods: {
        showMore() {
            this.$parent.doClickLog('seeMore', {});
            let {channelid} = getUrlParams();
            let params = {
                data: {
                    pNum: `${this.pNum}`,
                    pSize: '3',
                    channelid,
                },
            };
            if (!this.hasMoreData || this.loadingMoreData) {
                return;
            }
            this.loadingMoreData = true;
            api.strategy.getRankResult(params).then(res => {
                if (res && res.length > 0) {
                    this.list = this.list.concat(res);
                    this.pNum++;
                    if (res.length < 3) {
                        this.hasMoreData = false;
                    }
                }
                else {
                    this.hasMoreData = false;
                }
                this.loadingMoreData = false;
                this.$parent.doShowItemsLog(res);
            }).catch(() => {
                this.hasMoreData = false;
            });
        },
        doJumpPage(item) {
            setTimeout(() => {
                window.location.href = 'http://gamecenter.baidu.com/static/game/gamerank.html?flag=newrank&tagName=' + item.rank_name + '&channelid=' + getQueryString('channelid');
            }, 100);
            this.$parent.doClickLog('listBlank', {
                moduleName: item.rank_name,
                clickBtnType: 'listBlank',
            });
        },
        doJumpDetail(item, index, name) {
            const url = 'http://gamecenter.baidu.com/static/game/newdetail.html?appid=' + item.appid + '&channelid=' + getQueryString('channelid');
            setTimeout(() => {
                location.href = url;
            }, 100);
            this.$parent.doClickLog('game', {
                moduleName: name,
                clickBtnType: 'detail',
                gameName: item.app_name,
                gameType: '',
                gameId: item.appid,
            }, index + 1, item.package_name);
        },
    },
};
</script>
<style lang="scss">
@import "~@/common/style/mixin/utils";

$design-width: 1242;
$max-device-width: 768px;

.recommend-rank-wrapper {
    background-color: #fff;
    border-radius: px2rem(36);
    padding: px2rem(63) px2rem(39);
    .title {
        font-size: px2rem(57);
        margin-bottom: px2rem(53);
        font-weight: bold;
    }
    .rank-item-wrapper {
        width: 100%;
        height: px2rem(585);
        border-radius: px2rem(36);
        background-size: cover;
        margin-bottom: px2rem(27);
        .rank-item {
            height: px2rem(588);
            padding: px2rem(60) 0;
            border-radius: px2rem(36);
            box-sizing: border-box;
            .rank-item-title {
                font-size: px2rem(57);
                margin-left: px2rem(36);
            }
            .rank-item-link {
                font-size: px2rem(36);
                color: #858585;
                margin-top: px2rem(20);
                margin-left: px2rem(39);
                display: flex;
                img {
                    width: px2rem(50);
                    height: px2rem(48);
                    margin-left: px2rem(15);
                }
            }
            .rank-item-list {
                display: flex;
                margin-top: px2rem(50);
                .list-item {
                    width: px2rem(276);
                    text-align: center;
                    position: relative;
                    .rank-icon {
                        position: absolute;
                        width: px2rem(61);
                        left: px2rem(34);
                    }
                    .item-icon {
                        width: px2rem(188);
                        height: px2rem(188);
                    }
                    .app-name {
                        font-size: px2rem(42);
                        margin-top: px2rem(-21);
                        padding: 0 px2rem(10);
                        margin-top: px2rem(8);
                    }
                }
            }
        }
    }
    .show-more {
        font-size: px2rem(42);
        margin-top: px2rem(40);
        color: #858585;
        text-align: center;
    }
}
</style>